import type { Assignment } from "@cs2/contracts/domain";

/**
 * Abspielplan für die Schritt-Wiedergabe.
 *
 * Schritte tragen optional `offsetSeconds` (Rundenzeit als Countdown, also
 * absteigend). Daraus ergeben sich die echten Abstände zwischen zwei Schritten.
 * Fehlt die Zeit — bei Drafts der Normalfall — greift ein fester Takt, damit
 * die Wiedergabe trotzdem etwas zeigt statt sofort durchzurauschen.
 */
export const fallbackStepDurationMs = 2500;
const maxStepDurationMs = 15_000;

export interface PlaybackStep {
  order: number;
  durationMs: number;
}

export function buildPlayback(assignment: Assignment): PlaybackStep[] {
  const steps = [...assignment.steps].sort((left, right) =>
    left.order === right.order ? 0 : left.order < right.order ? -1 : 1,
  );
  return steps.map((step, index) => {
    const next = steps[index + 1];
    const from = step.offsetSeconds;
    const to = next?.offsetSeconds;
    if (
      next === undefined ||
      from === null ||
      from === undefined ||
      to === null ||
      to === undefined
    )
      return { order: step.order, durationMs: fallbackStepDurationMs };
    // Countdown läuft rückwärts: der spätere Schritt hat die kleinere Zahl.
    const seconds = from - to;
    if (seconds <= 0)
      return { order: step.order, durationMs: fallbackStepDurationMs };
    return {
      order: step.order,
      durationMs: Math.min(seconds * 1000, maxStepDurationMs),
    };
  });
}
